function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

export default ownerDocument;
//# sourceMappingURL=owner-document.esm.js.map
